<p-panel
  [styleClass]="panelStyleClass"
  [toggleable]="true"
  [collapsed]="false"
  [expandIcon]="'pi pi-chevron-up'"
  [collapseIcon]="'pi pi-chevron-down'"
>
  <ng-template pTemplate="header">
    <div class="flex justify-content-between" style="width: 100%">
      <h4 class="flex gap-2 align-items-center">
        <span
          class="{{ config?.headerIcon }} 
              {{ config?.headerIconStyleClass }}"
        ></span>
        <span class="{{ config?.headerStyleClass }}">
          {{ config?.header }}
        </span>
      </h4>
      <div class="flex">
        <p-button
          *ngFor="let button of config?.headerButtons"
          class="p-button-collapsible"
          styleClass="p-button-text {{ button?.styleClass }}"
          [icon]="button?.icon"
          [label]="button?.label"
          [style]="{ height: '20px' }"
          (onClick)="button.onClick($event, value)"
        />

        <p-menu
          #menu
          popup
          appendTo="body"
          [style.min-width.px]="450"
          [tabindex]="undefined"
          [model]="getMenuItems()"
        />

        <button
          pButton
          *ngIf="hasVisibleMenuButtonItems()"
          icon="pi pi-ellipsis-v {{ headerMenuButtonIcon }}"
          class="p-button-rounded p-button-text {{
            headerMenuButtonStyleClass
          }}"
          [label]="headerMenuButtonLabel"
          (click)="menu.toggle($event)"
          [disabled]="config?.headerMenuButtonDisabled ?? false"
        ></button>
      </div>
    </div>
  </ng-template>

  <div [class]="itemContainerStyleClass">
    <ng-container *ngFor="let item of config?.items">
      <eo-detail-item
        *ngIf="getItemVisible(item)"
        [class]="item.styleClass ?? itemStyleClass"
        [title]="item.label"
        [value]="getItemValue(item.propertyName) || '-'"
        [severity]="item.severity"
        [valueType]="item.type"
        [loading]="loading"
      />
    </ng-container>
    @if(config?.tableConfig != undefined) {
    <eo-table
      [config]="tableConfig"
      [rowData]="tableValue"
      panelStyleClass="w-full"
      styleClass="w-full"
    />
    }
  </div>
</p-panel>
